import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import frCommon from './locales/fr/common.json'
import frAdmin from './locales/fr/admin.json'
import frExpert from './locales/fr/expert.json'
import frClient from './locales/fr/client.json'
import frBanque from './locales/fr/banque.json'

import enCommon from './locales/en/common.json'
import enAdmin from './locales/en/admin.json'
import enExpert from './locales/en/expert.json'
import enClient from './locales/en/client.json'
import enBanque from './locales/en/banque.json'

import deCommon from './locales/de/common.json'
import deAdmin from './locales/de/admin.json'
import deExpert from './locales/de/expert.json'
import deClient from './locales/de/client.json'
import deBanque from './locales/de/banque.json'

import nlCommon from './locales/nl/common.json'
import nlAdmin from './locales/nl/admin.json'
import nlExpert from './locales/nl/expert.json'
import nlClient from './locales/nl/client.json'
import nlBanque from './locales/nl/banque.json'

const resources = {
  fr: {
    common: frCommon,
    admin: frAdmin,
    expert: frExpert,
    client: frClient,
    banque: frBanque,
  },
  en: {
    common: enCommon,
    admin: enAdmin,
    expert: enExpert,
    client: enClient,
    banque: enBanque,
  },
  de: {
    common: deCommon,
    admin: deAdmin,
    expert: deExpert,
    client: deClient,
    banque: deBanque,
  },
  nl: {
    common: nlCommon,
    admin: nlAdmin,
    expert: nlExpert,
    client: nlClient,
    banque: nlBanque,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr', // French as default
    defaultNS: 'common',
    ns: ['common', 'admin', 'expert', 'client', 'banque'],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: false,
    },
  })

export default i18n